











































































import { AsLoginForm } from '@spa/components/pages/auth/login/components/mixin/as-login-form'
import LoadingMixin from '@spa/mixins/loading'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class Login extends Mixins<AsLoginForm & LoadingMixin>(AsLoginForm, LoadingMixin) {
  @Prop({ default: '/s/mypage' })
  /**
   * @see LoginPageProps.next
   */
  readonly next: string

  @Prop({ default: '/signup' })
  /**
   * @see LoginPageProps.signupLink
   */
  readonly signupLink: string

  get brandName(): string {
    return this.behavior.groupLabel
  }
}
